import { api, downloadFile } from './client'
import type { ReportMeta, UUID } from '@/types/api'

export const reportsApi = {
  meta: async (jobId: UUID): Promise<ReportMeta> =>
    (await api.get(`/jobs/${jobId}/report`)).data,

  downloadXlsx: (jobId: UUID) =>
    downloadFile(`/jobs/${jobId}/report.xlsx`, `report_${jobId.slice(0, 8)}.xlsx`),

  downloadJson: (jobId: UUID) =>
    downloadFile(`/jobs/${jobId}/report.json`, `report_${jobId.slice(0, 8)}.json`),

  downloadPdf: (jobId: UUID) =>
    downloadFile(`/jobs/${jobId}/report.pdf`, `report_${jobId.slice(0, 8)}.pdf`),
}
